<template>
  <b-card no-body>
    <b-card-header class="pb-50">
      <h5>{{ $t("Filters") }}</h5>
    </b-card-header>
    <b-card-body>
      <b-row>
        <b-col cols="12" md="3" class="mb-md-0 mb-2">
          <label>{{ $t("tableHeader.name") }}</label>
          <b-form-input 
            autofocus 
            v-model.trim="filters.name" 
            @keyup.enter="searchFilter" 
            placeholder="Enter patient name..." 
          />
        </b-col>
        <b-col cols="12" md="3" class="mb-md-0 mb-2">
          <label>{{ $t("Form.Phone") }}</label>
          <b-form-input 
            v-model.number="filters.phone" 
            @keyup.enter="searchFilter" 
            placeholder="Enter phone number..." 
          />
        </b-col>
        <b-col cols="12" md="3" class="mb-md-0 mb-2">
          <label>DOB</label>
          <flat-pickr 
            v-model="filters.date_birth" 
            :config="config" 
            class="form-control" 
            placeholder="MM-DD-YYYY" 
          />
        </b-col>
        <b-col cols="12" md="3" class="mb-md-0 mb-2">
          <label>Patient Type</label>
          <treeselect 
            v-model="filters.patient_type" 
            :options="patientTypeOptions" 
            :normalizer="normalizer"
            @keyup.enter="searchFilter"
            placeholder="Select patient type..."
          />
        </b-col>
        <b-col cols="12" md="3" class="mb-md-0 mb-2">
          <label>{{ $t("Form.Gender") }}</label>
          <treeselect 
            v-model="filters.gender" 
            :options="genderOptions" 
            :normalizer="normalizer"
            @keyup.enter="searchFilter"
            placeholder="Select gender..."
          />
        </b-col>
        <b-col cols="12" md="3" class="mb-md-0 mb-2">
          <label>{{ $t("Form.Status") }}</label>
          <treeselect 
            v-model="filters.status" 
            :options="statusOptions" 
            :normalizer="normalizer"
            @keyup.enter="searchFilter"
            placeholder="Select status..."
          />
        </b-col>
        <b-col cols="12" md="3" class="mb-md-0 mb-2">
          <label>Has Insurance</label>
          <treeselect 
            v-model="filters.has_insurance" 
            :options="insuranceOptions" 
            :normalizer="normalizer"
            @keyup.enter="searchFilter"
            placeholder="Select insurance status..."
          />
        </b-col>
        <b-col cols="12" md="3" class="mb-md-0 mb-2">
          <label>Visit Count</label>
          <b-form-input 
            v-model.number="filters.visit_count" 
            @keyup.enter="searchFilter" 
            placeholder="Min visit count..." 
            type="number"
          />
        </b-col>
        <b-col cols="12" class="mb-md-0 mb-2 mt-2" align="end">
          <b-button 
            variant="success" 
            @click="excel" 
            class="mr-1" 
            v-if="$can('index', 'administration')"
          >
            Excel
          </b-button>
          <b-button 
            variant="warning" 
            @click="resetFilter" 
            class="mr-1"
          >
            {{ $t("Clear") }}
          </b-button>
          <b-button 
            variant="primary" 
            @click="searchFilter" 
            :disabled="loading"
          >
            <span v-if="!loading">{{ $t("Search") }}</span>
            <span v-else>
              <SpinnerLoading />
            </span>
          </b-button>
        </b-col>
      </b-row>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard,
  BCardHeader,
  BCardBody,
  BRow,
  BCol,
  BFormInput,
  BButton,
} from "bootstrap-vue";

import SpinnerLoading from "@/components/SpinnerLoading";
import flatPickr from "vue-flatpickr-component";
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';

export default {
  name: 'FilterReleasePatients',
  components: {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    BFormInput,
    BButton,
    flatPickr,
    SpinnerLoading,
    Treeselect,
  },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      filters: {
        name: null,
        phone: null,
        date_birth: null,
        patient_type: null,
        gender: null,
        status: null,
        has_insurance: null,
        visit_count: null,
      },
      patientTypeOptions: [
        { name: "Cash", id: "normal" },
        { name: "Insurance", id: "insurance" },
      ],
      genderOptions: [
        { name: this.$t("Male"), id: "male" },
        { name: "Female", id: "female" },
      ],
      statusOptions: [
        { name: "Active", id: "true" },
        { name: "Inactive", id: "false" },
      ],
      insuranceOptions: [
        { name: "Has Insurance", id: "true" },
        { name: "No Insurance", id: "false" },
      ],
      config: {
        dateFormat: "m-d-Y", 
        allowInput: true,
      },
      normalizer(node) {
        return {
          id: node.id,
          label: node.name,
        };
      },
    };
  },
  methods: {
    excel() {
      this.$emit('exportExcel');
    },
    searchFilter() {
      const data = this.filters;
      console.log("🚀 ~ searchFilter ~ data:", data);
      this.$emit("searchFilter", JSON.parse(JSON.stringify(data)));
      
      // Check if any filter is active
      const {
        name,
        phone,
        date_birth,
        patient_type,
        gender,
        status,
        has_insurance,
        visit_count,
      } = this.filters;
      
      const hasActiveFilters = Boolean(
        name || phone || date_birth || patient_type || 
        gender || status || has_insurance || visit_count
      );
      
      this.$emit("filterPage", hasActiveFilters);
    },
    resetFilter() {
      const filter = JSON.parse(JSON.stringify(this.filters));
      for (const iterator in filter) {
        this.filters[iterator] = null;
      }
      this.searchFilter(); // Trigger search after reset
    },
  },
};
</script>

<style scoped>
.pb-50 {
  padding-bottom: 0.5rem;
}
</style> 